<template>
  <v-footer
    class="footer"
    :dark="false"
    :padless="true"
    app
    elevation="0"
    color="transparent"
  >
    <v-row justify="center" no-gutters>
      <v-btn
        color="transparent"
        rounded
        depressed
        @click="logout"
        v-if="this.$store.getters['Authenticate/isLoggedIn']"
        ><v-icon left>fas fa-power-off</v-icon>&nbsp;&nbsp;Logout</v-btn
      >
    </v-row>
  </v-footer>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch("Authenticate/logout");
    },
  },
};
</script>
